module.exports = __webpack_public_path__ + "static/media/css3.3f8e68f4.png";